
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-persona",
      function () {
        return require("private-next-pages/the-persona/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-persona"])
      });
    }
  